import { SortingRule } from 'react-table';
import { IdashboardDataParams, IdashboardItem } from '../../models';
import { constants } from '../../constants/constants';

export const initialDataParams: IdashboardDataParams = {
    // /* default search and filter */
    search: '',
    filter: '',
    sort: 'startDate',
    descending: true,
    startDate: new Date(Date.now() + 60 * 24 * 60 * 60 * 1000).toISOString().split('T')[0] || '', // don't show anything starting 60 days into the future

    /* to show mostly work orders */
    // search: '',
    // filter: '',
    // sort: 'jobNumber',
    // descending: false,
    // startDate: undefined,

    /* to show work orders with and without jobs */
    // search: '9-1',
    // filter: '',
    // sort: 'serialNumber',
    // descending: false,
    // startDate: undefined,

    /* always a default */
    page: 0,
    pageSize: constants.tablePageSizeDefault
};

export const defaultTableSort: SortingRule<IdashboardItem> = {
    id: initialDataParams.sort || '',
    desc: initialDataParams.descending
};

export const getSavedDataParams = () => {
    const value = localStorage.getItem('dashboardDataParams');
    if (!value) return initialDataParams;
    
    const parsed = JSON.parse(value) as IdashboardDataParams;
    // Normalize legacy "status" to "jobStatus" for backward compatibility
    if (parsed.sort === 'status') {
        parsed.sort = 'jobStatus';
    }
    return parsed;
};

export const applyUserDefaultSort = (params: IdashboardDataParams, userDefaultSort?: string): IdashboardDataParams => {
    if (!userDefaultSort) return params;
    
    // Normalize legacy "status" to "jobStatus" for backward compatibility
    const normalizedSort = userDefaultSort === 'status' ? 'jobStatus' : userDefaultSort;
    
    const allowed = new Set([
        'jobStatus',
        'jobNumber',
        'workOrderNumber',
        'facilityName',
        'description',
        'city',
        'startDate',
        'orderType',
        'hours',
        'partStatus'
    ]);
    if (!allowed.has(normalizedSort)) return params;
    
    // Check if there's saved data in localStorage (indicating user has interacted with dashboard)
    // If saved data exists, preserve the saved sort instead of applying user default
    // This ensures user's explicit sort choices are retained when navigating back
    const savedValue = localStorage.getItem('dashboardDataParams');
    if (savedValue) {
        try {
            const savedParams = JSON.parse(savedValue) as IdashboardDataParams;
            // If saved params have a sort value, preserve it (user's explicit choice overrides default)
            if (savedParams.sort) {
                return params;
            }
        } catch (e) {
            // If parsing fails, fall through to apply default
        }
    }
    
    // Only apply default sort if no saved data exists in localStorage
    // This applies user default for new users or when localStorage is cleared
    return { ...params, sort: normalizedSort, descending: normalizedSort === 'startDate' ? true : false };
};
export const setSavedDataParams = (params: IdashboardDataParams) => {
    localStorage.setItem('dashboardDataParams', JSON.stringify(params));
};

export const getInitialDataParamsWithUserDefault = (userDefaultSort?: string): IdashboardDataParams => {
    // Start with base initial params
    const params = { ...initialDataParams };
    
    // If user has a default sort, apply it
    if (userDefaultSort) {
        // Normalize legacy "status" to "jobStatus" for backward compatibility
        const normalizedSort = userDefaultSort === 'status' ? 'jobStatus' : userDefaultSort;
        
        const allowed = new Set([
            'jobStatus',
            'jobNumber',
            'workOrderNumber',
            'facilityName',
            'description',
            'city',
            'startDate',
            'orderType',
            'hours',
            'partStatus'
        ]);
        
        if (allowed.has(normalizedSort)) {
            params.sort = normalizedSort;
            params.descending = normalizedSort === 'startDate' ? true : false;
        }
    }
    
    return params;
};
